import Err403 from 'components/sys/err-403'
import Err404 from 'components/sys/err-404'
import Err502 from 'components/sys/err-502'
import Login from 'components/sys/login'
import Home from 'components/sys/home/home'
import HomePage from 'components/sys/home/home-page'

import LoudSpeakLearnLearnTime from 'components/loud-speak-learn/learn-time'
import LoudSpeakLearnLearnAndSkill from 'components/loud-speak-learn/learn-and-skill'
import LoudSpeakOperateOrder from 'components/loud-speak-operate/order'
import LoudSpeakOperateUser from 'components/loud-speak-operate/user'
import VoipOperate from 'components/voip-operate/voip-operate'
import LearnDetails from 'components/learn-details/learn-details'
// import LearnDetailsSchool from 'components/learn-details/learn-details-school'
import LearnDetailsQoocobar from 'components/learn-details/learn-details-qoocobar'
import learnDetailsClubweeks from 'components/learn-details/learn-details-clubweeks'
import VoIPDetails from 'components/voip-details/voip-details'
import OperateDetails from 'components/operate-details/operate-details'
import CardSearch from 'components/card-course-search/card-search'
import CourseSearch from 'components/card-course-search/course-search'
// English Certificate
import TalentShow from 'components/english-certificate/talent-show'
// lazy load
const cardFinance = () => import('components/headquarters/card-finance')
const clubWeekMonth = () => import('components/headquarters/club-week-month')
const clubWeekMonthSg = () => import('components/headquarters/club-week-month-sg')
const aiData = () => import('components/headquarters/ai-data')
// wildData
const exportExcel = () => import('components/wild-data/export-excel')
// quickData
const quickData = () => import('components/quick-data/quick-data')
// {roles: 'ROLE_QOOCO'}
let routes = [
  { path: '/',
    component: Home,
    meta: {auth: true},
    hidden: true,
    children: [
      { path: '/', component: HomePage, name: 'default', hidden: true }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: 'ROLE_QOOCO'}},
    name: 'loudSpeakLearn',
    alias: '学习综合项排行榜',
    children: [
      { path: '/loudSpeakLearn/learnTime', component: LoudSpeakLearnLearnTime, name: 'loudSpeakLearnLearnTime', alias: '时间排行', meta: {auth: {roles: 'ROLE_QOOCO'}} },
      { path: '/loudSpeakLearn/learnAndSkill', component: LoudSpeakLearnLearnAndSkill, name: 'loudSpeakLearnLearnAndSkill', alias: '其它单项排行', meta: {auth: {roles: 'ROLE_QOOCO'}} }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: 'ROLE_QOOCO'}},
    name: 'loudSpeakOperate',
    alias: '订单综合排行榜',
    children: [
        { path: '/loudSpeakOperate/order', component: LoudSpeakOperateOrder, name: 'operateOrder', alias: '订单排行', meta: {auth: {roles: 'ROLE_QOOCO'}} },
        { path: '/loudSpeakOperate/user', component: LoudSpeakOperateUser, name: 'operateUser', alias: '学校订单历史明细', meta: {auth: {roles: 'ROLE_QOOCO'}} }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: 'ROLE_DEV'}},
    name: 'voipOperate',
    alias: 'VoIP运营数据',
    children: [
        { path: '/voipOperate/voipOperate', component: VoipOperate, name: 'operateOrder1', alias: 'VoIP运营数据', meta: {auth: {roles: 'ROLE_QOOCO'}} }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: ['ROLE_QOOCO', 'ROLE_SCHOOL']}},
    name: 'learnDetails',
    alias: '学习数据',
    children: [
        { path: '/learnDetails/learnDetails', component: LearnDetails, name: 'learnDetails1', alias: '学生数据', meta: {auth: {roles: ['ROLE_QOOCO', 'ROLE_SCHOOL']}} },
        // { path: '/learnDetails/school', component: LearnDetailsSchool, name: 'learnDetails2', alias: '学校数据' },
        { path: '/learnDetails/qoocobar', component: LearnDetailsQoocobar, name: 'learnDetails3', alias: '语吧周内详情', meta: {auth: {roles: ['ROLE_QOOCO', 'ROLE_SCHOOL']}} },
        { path: '/learnDetails/clubWeeks', component: learnDetailsClubweeks, name: 'learnDetails4', alias: '语吧周度对比', meta: {auth: {roles: ['ROLE_QOOCO', 'ROLE_SCHOOL']}} }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: 'ROLE_DEV'}},
    name: 'voipDetails',
    alias: 'VoIP详细数据',
    children: [
        { path: '/voipDetails/voipDetails', component: VoIPDetails, name: 'voipDetails1', alias: 'VoIP详细数据', meta: {auth: {roles: 'ROLE_QOOCO'}} }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: ['ROLE_QOOCO', 'ROLE_SCHOOL']}},
    name: 'operateDetails',
    alias: '充值卡综合数据',
    children: [
        { path: '/operateDetails/operateDetails', component: OperateDetails, name: 'operateDetails1', alias: '学生充值卡明细', meta: {auth: {roles: ['ROLE_QOOCO', 'ROLE_SCHOOL']}} }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: 'ROLE_QOOCO'}},
    name: 'cardAndCourseSearch',
    alias: '快速查询工具',
    children: [
      { path: '/cardAndCourseSearch/cardSearch', component: CardSearch, name: 'CardSearch', alias: '卡密查询', meta: {auth: {roles: 'ROLE_QOOCO'}} },
      { path: '/cardAndCourseSearch/courseSearch', component: CourseSearch, name: 'CourseSearch', alias: '用户卡密及课程查询', meta: {auth: {roles: 'ROLE_QOOCO'}} }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: 'ROLE_QOOCO'}},
    name: 'headquarters',
    alias: '总部数据统计',
    children: [
      { path: '/headquarters/cardFinance', component: cardFinance, name: 'cardFinance', alias: '卡密/财务数据', meta: {auth: {roles: 'ROLE_QOOCO'}} },
      { path: '/headquarters/clubWeekMonth', component: clubWeekMonth, name: 'clubWeekMonth', alias: '语吧周、月数据', meta: {auth: {roles: 'ROLE_QOOCO'}} },
      { path: '/headquarters/clubWeekMonthSg', component: clubWeekMonthSg, name: 'clubWeekMonthSg', alias: '语吧周、月数据-海外', meta: {auth: {roles: 'ROLE_QOOCO'}} },
      { path: '/headquarters/aiData', component: aiData, name: 'aiData', alias: '巧口AI英语数据', meta: {auth: {roles: 'ROLE_QOOCO'}} }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: 'ROLE_QOOCO'}},
    name: 'wildData',
    alias: '未归类数据',
    children: [
      { path: '/wildData/exportExcel', component: exportExcel, name: 'exportExcel', alias: '导出Excel', meta: {auth: {roles: 'ROLE_QOOCO'}} }
    ]
  }, {
    path: '/',
    component: Home,
    meta: {auth: {roles: 'ROLE_QOOCO'}},
    name: 'quickData',
    alias: '快速导出数据',
    children: [
      { path: '/quickData/exportExcel', component: quickData, name: 'quickData', alias: '导出Excel', meta: {auth: {roles: 'ROLE_QOOCO'}} }
    ]
  }, {
    path: '/login',
    component: Login,
    name: 'login',
    alias: '登录',
    meta: {
      auth: false
    },
    hidden: true
  }, {
    path: '/403',
    name: 'error-403',
    component: Err403,
    hidden: true
  }, {
    path: '/404',
    name: 'error-404',
    component: Err404,
    hidden: true
  }, {
    path: '/502',
    name: 'error502',
    component: Err502,
    hidden: true
  }, {
    path: '/talentshow',
    name: 'talentshow',
    component: TalentShow,
    meta: {
      auth: false
    },
    hidden: true
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js